import { useEffect, useState } from "react";
import { Input, Spinner } from "reactstrap";
import funcoes from "../../models/funcoes";

function DynamicSelectFunction({ id_node, onParamChange, data, node }) {
  const [my_options, setOptions] = useState([]);
  const [load, setLoad] = useState(true);

  async function getParamsData() {
    setLoad(true);
    try {
      const final_id = id_node.split("_")[0];
      const res = await funcoes.getDynamicParams(final_id, data, data.label);

      setOptions(res);
      if (res?.length > 0 && !data?.value) {
        onParamChange(id_node, data.id, res[0]);
      }
    } catch (e) {
      console.log(id_node, e);
    }
    setLoad(false);
  }

  useEffect(() => {
    getParamsData();
  }, [node]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        gap: 10,
        alignItems: "center",
      }}
    >
      <Input
        type="select"
        value={data?.value}
        disabled={load}
        required={data?.obrigatory}
        onChange={({ target }) => onParamChange(id_node, data.id, target.value)}
      >
        {load && data?.value ? (
          <option value={data?.value}>{data?.value}</option>
        ) : null}

        {my_options.map((e) => (
          <option value={e}>{e}</option>
        ))}
      </Input>
      {load && <Spinner size="sm" color="primary" />}
    </div>
  );
}

export default DynamicSelectFunction;
